export type GmailErrorCode =
  | 'popup_closed'
  | 'scope_denied'
  | 'no_gmail'
  | 'admin_blocked'
  | 'rate_limited'
  | 'token_rejected'
  | 'upstream';

// Carries the code only: Google's own error text never leaves the module that read it.
export class GmailError extends Error {
  readonly code: GmailErrorCode;

  constructor(code: GmailErrorCode) {
    super(`gmail:${code}`);
    this.name = 'GmailError';
    this.code = code;
  }
}

export type InvalidDraftField =
  | 'from'
  | 'to'
  | 'subject'
  | 'filename'
  | 'content_type';

// Our own draft data failed a header rule; Gmail was never asked.
export class InvalidDraftError extends Error {
  readonly field: InvalidDraftField;

  constructor(field: InvalidDraftField) {
    super(`invalid draft ${field}`);
    this.name = 'InvalidDraftError';
    this.field = field;
  }
}
